import { BASE_URL } from "../../../configs/api";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "../../../utils/storage";
import { errorHandler } from "../../../utils/errorHandler";

export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders(headers) {
      headers.set("Accept", `application/json`);
      const token = getToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getStats: builder.query<any, void>({
      query: () => ({ url: "/v1/admin/stats" }),
      async onQueryStarted(_, apiHelpers) {
        const { queryFulfilled } = apiHelpers;

        try {
          await queryFulfilled;
        } catch (error) {
          errorHandler(error);
        }
      },
    }),
  }),
});

export const { useGetStatsQuery } = dashboardApi;
